var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{ref:"refTable",attrs:{"columns":_vm.tableColumn,"data":_vm.list,"min-height":30,"rowConfig":{
    isCurrent: false
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }